import { bigNumberToText } from '../utils';
import { Icon, Icons } from '@silverfort/sf-components';
import { MetricItem } from './Types';
import style from './ModuleMetrics.module.scss';
import { useDashboardContext } from './DashboardContext';
import CrossFade from './CrossFade';

type ModuleMetricsProps = {
    metrics?: Record<string, MetricItem>;
    info?: { funFact: string };
    isDisabled: boolean;
};

const Content = ({ metrics, info, isDisabled }: ModuleMetricsProps) => {
    if (isDisabled && info) {
        return (
            <section className="flex gap-[1.25vw] w-[25vw] items-center justify-center">
                <aside className="w-[5vh] h-[5vh] bg-sf-black border border-sf-sunset-400 rounded-[50%] flex items-center justify-center grow-0 shrink-0">
                    <Icon icon={Icons.LightBulbGradient} size={24} />
                </aside>
                <section className="text-sf-white">
                    <h4 className="pb-[0.96vh] text-[2.2vh] font-medium font-['Bitter']">Did you know?</h4>
                    <p className="text-[1.56vh]">{info.funFact}</p>
                </section>
            </section>
        );
    }

    const metricsArray = Object.values(metrics || {});

    if (metricsArray.length === 1) {
        return (
            <section className="text-sf-white text-center">
                <h4 className="text-[3.85vh] font-medium font-sf-poppins pb-[0.96vh]">
                    {bigNumberToText(metricsArray[0].value)}
                </h4>
                <h5 className="text-[1.9vh]">{metricsArray[0].label}</h5>
            </section>
        );
    }

    return (
        <ul className="flex gap-[1.25vw] items-center justify-center">
            {metricsArray?.map((item, index) => (
                <li key={index} className={style.multiItem}>
                    <span className="text-sf-sunset-100 text-[3.36vh] font-sf-poppins">
                        {bigNumberToText(item.value)}
                    </span>
                    <span className="text-sf-white text-[1.7vh] text-center">{item.label}</span>
                </li>
            ))}
        </ul>
    );
};

const ModuleMetrics = () => {
    const { currentModule, systemStatistics } = useDashboardContext();

    const defaultMetrics = {
        auth: { value: systemStatistics.totalAuthentications, label: 'Authentications' }
    };

    const metrics: Record<string, MetricItem> = currentModule?.metrics || defaultMetrics;
    const isDisabled = Boolean(currentModule?.isDisabled);
    const moduleInfo = currentModule?.info;

    const identity = isDisabled
        ? `disabled-${currentModule?.title || ''}`
        : Object.values(metrics)
              .map((m) => `${m.label}-${m.value}`)
              .join('|');

    return (
        <div className="absolute bottom-[11%] left-1/2 -translate-x-1/2 translate-y-1/2 h-[5vh] w-full">
            <CrossFade
                identity={identity}
                className="flex justify-center"
                content={<Content isDisabled={isDisabled} metrics={metrics} info={moduleInfo} />}
            />
        </div>
    );
};

export default ModuleMetrics;
